// src/components/FormSectionSubHeader.js

import React from "react";
import PropTypes from "prop-types";
import { Typography, Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Define styles using makeStyles
const useStyles = makeStyles((theme) => ({
  subHeaderContainer: {
    marginBottom: theme.spacing(1),
    textAlign: "center",
    // Responsive padding
    paddingRight: theme.spacing(8),
    paddingLeft: theme.spacing(8),
    [theme.breakpoints.down("md")]: {
      paddingRight: theme.spacing(5),
      paddingLeft: theme.spacing(5),
    },
    [theme.breakpoints.down("sm")]: {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
    },
    [theme.breakpoints.down("xs")]: {
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
    },
  },
  subHeaderText: {
    fontWeight: 600,
    fontSize: "1.5rem", // Default size
    lineHeight: 1.2,
    [theme.breakpoints.down("md")]: {
      fontSize: "1.3rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.1rem",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "1rem",
      overflowWrap: "break-word", // Allow words to break
      wordWrap: "break-word", // Legacy support
      hyphens: "auto", // Enable hyphenation
    },
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
}));

/**
 * FormSectionSubHeader Component
 * Renders a subheader with a title and a divider.
 * Now visible on all screen sizes with responsive styling.
 *
 * @param {string} title - The text to display as the subheader.
 */
const FormSectionSubHeader = ({ title }) => {
  const classes = useStyles();

  return (
    <div className={classes.subHeaderContainer}>
      <Typography
        variant="h6"
        className={classes.subHeaderText}
        align="center"
        style={{
          display: "block", // Ensure it's a block element
          width: "100%", // Take full width
          maxWidth: "100%", // Ensure it doesn't overflow
        }}
      >
        {title}
      </Typography>
      <Divider className={classes.divider} />
    </div>
  );
};

FormSectionSubHeader.propTypes = {
  title: PropTypes.string.isRequired,
};

export default FormSectionSubHeader;
